export default __webpack_public_path__ + "static/media/img-ovato-coin-stack-new.45472fa5.png";